import React from 'react';
import { OneWayInFeedbackCollectionDto, OneWayInOpportunityDto, OneWayInStatus } from 'src/api/v2';

const useFeedbackMissing = (
  feedbackCollection: OneWayInFeedbackCollectionDto | undefined,
  opportunity: OneWayInOpportunityDto | undefined,
) => {
  return React.useMemo(() => {
    if (
      opportunity === undefined ||
      feedbackCollection?.actorFeedback ||
      //if the opportunity is referred from another actor, the first object in the history array will always have the recieved status
      opportunity?.history[0].status === OneWayInStatus.Received
    )
      return false;
    return true;
  }, [opportunity, feedbackCollection]);
};

export default useFeedbackMissing;
